import {
  DELETE_CREDENTIALS_REQUEST_ASYNC,
  DISABLE_INTEGRATION_REQUEST_ASYNC,
  ENABLE_INTEGRATION_REQUEST_ASYNC,
  SET_LOADER,
  STATUS_REQUEST_ASYNC,
} from './constants'

export const getStatus = () => ({ type: STATUS_REQUEST_ASYNC.INITIATE })

export const setLoader = (payload) => ({
  type: SET_LOADER,
  payload,
})

export const getStatusSuccess = (data) => ({
  type: STATUS_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const getStatusError = (error) => ({
  type: STATUS_REQUEST_ASYNC.ERROR,
  error,
})

export const enableIntegration = () => ({
  type: ENABLE_INTEGRATION_REQUEST_ASYNC.INITIATE,
})
export const enableIntegrationSuccess = (data) => ({
  type: ENABLE_INTEGRATION_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const enableIntegrationError = (error) => ({
  type: ENABLE_INTEGRATION_REQUEST_ASYNC.ERROR,
  error,
})

export const disableIntegration = () => ({
  type: DISABLE_INTEGRATION_REQUEST_ASYNC.INITIATE,
})
export const disableIntegrationSuccess = (data) => ({
  type: DISABLE_INTEGRATION_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const disableIntegrationError = (error) => ({
  type: DISABLE_INTEGRATION_REQUEST_ASYNC.ERROR,
  error,
})

export const deleteCredentials = () => ({
  type: DELETE_CREDENTIALS_REQUEST_ASYNC.INITIATE,
})
export const deleteCredentialsSuccess = (data) => ({
  type: DELETE_CREDENTIALS_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const deleteCredentialsError = (error) => ({
  type: DELETE_CREDENTIALS_REQUEST_ASYNC.ERROR,
  error,
})

export default {
  // to props
  getStatus,
  enableIntegration,
  disableIntegration,
  deleteCredentials,
  setLoader,
}
